import React, { useState, useRef } from 'react';
import "../css/newsletter.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ReCAPTCHA from 'react-google-recaptcha'
import axios from 'axios';
import emailjs from '@emailjs/browser';
import {useSiteSettings} from "../sanity/useSiteSettings";
import { LoadingSpinner } from "../UI/LoadingSpinner";

const Newsletter = () => {
    const form = useRef();
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [error, setError] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const {data, loading} = useSiteSettings();
    const newsletter = data?.newsletter || {};
    const labels = newsletter.labels || {};


    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_xulgmhk', 'template_dqehj6p', form.current, {
                publicKey: 'HFShCuoJcxkJ_3wKT',
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!recaptchaToken) {
            setError(newsletter.recaptchaError || 'Bitte vervollständigen Sie das reCAPTCHA.');
            return;
        }
        try {
            const response = await axios.post('https://biodanzafreiburgnode.netlify.app/.netlify/functions/app/subscribe', {
                email,
                firstName,
                lastName,
                phoneNumber,
                recaptchaToken
            });
            const { success, message } = response.data || {};
            const isDuplicate = typeof message === 'string' && message.toLowerCase().includes('bereits abonniert');

            if (isDuplicate) {
                setError(newsletter.duplicateError || 'Diese E-Mail ist bereits abonniert.');
                return;
            }

            if (success) {
                setSubscribed(true);
                sendEmail(e);
                return;
            }
        } catch (error) {
            console.error('Error subscribing:', error);
            if (error.response && error.response.data) {
                const backendMessage = error.response.data.message;
                const backendDetail = error.response.data.detail;
                if (backendMessage || backendDetail) {
                    const combined = [backendMessage, backendDetail].filter(Boolean).join(' – ');
                    setError(combined);
                    return;
                }
            }
            setError(newsletter.genericError || 'Fehler beim Abonnieren. Bitte versuchen Sie es später erneut.');
        }


    };

    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
        setError('');
    };

    const key = process.env.REACT_APP_SITE_KEY;

    if (loading && !data) {
        return (
            <div className="center newsletter-bg ">
                <div className="newsletter-container d-flex flex-column">
                    <LoadingSpinner label="Lädt…" size="lg" />
                </div>
            </div>
        )
    }

    return (
        <div className="center newsletter-bg ">
            <div className="newsletter-container d-flex flex-column">

                <h3 className='image-text'>
                    {newsletter.title || 'NEWSLETTER'}
                </h3>
                {!subscribed ? (
                    <form className="d-flex flex-column align-items-center" ref={form} onSubmit={handleSubmit}>

                        <p className="newsletter-subtitle">
                            {newsletter.subtitle || 'Trag dich hier ein, um regelmäßig Informationen über alle kommenden Veranstaltungen zu erhalten.'}
                        </p>

                        <div className="form__group field">
                            <input type="input"
                                className="form__field"
                                placeholder={labels.firstName || "Vorname"} name="vorname" id='vorname'
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required />
                            <label htmlFor="vorname" className="form__label">{labels.firstName || "Vorname"}</label>
                        </div>

                        <div className="form__group field">
                            <input type="input"
                                className="form__field"
                                placeholder={labels.lastName || "Nachname"} name="nachname" id='nachname'
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required />
                            <label htmlFor="nachname" className="form__label">{labels.lastName || "Nachname"}</label>
                        </div>

                        <div className="form__group field">
                            <input type="nummer"
                                className="form__field"
                                placeholder={labels.phone || "Telefonnummer (optional)"} name="phone" id='phone'
                                // pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)} />
                            <label htmlFor="phone" className="form__label">{labels.phone || "Telefonnummer (optional)"}</label>
                        </div>

                        <div className="form__group field">
                            <input type="email"
                                className="form__field"
                                placeholder={labels.email || "Deine Email"} name="email" id='email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required />
                            <label htmlFor="email" className="form__label">{labels.email || "Deine Email"}</label>
                        </div>

                        <div className="newsletter-recaptcha">
                            <ReCAPTCHA sitekey={key} onChange={handleRecaptchaChange} />

                        </div>

                        {error && <p className="newsletter-error">{error}</p>}

                        <button type="submit" className="readMoreButton ">
                            {(newsletter.buttonLabel || 'Abonnieren')} <FontAwesomeIcon icon={faArrowRight} />
                        </button>



                    </form>
                ) : (
                    <p>{newsletter.successMessage || 'Vielen Dank für deine Anmeldung!'}</p>
                )}



                <div className="center">
                    <p className="newsletter-unsubscribe" >
                        {newsletter.disclaimer || 'Die E-Mail-Adresse wird ausschließlich dazu verwendet, unseren Newsletter und Informationen der Biodanza-Schule Freiburg zu versenden und nicht an Dritte weitergegeben. Der Newsletter kann jederzeit über den "Unsubscribe / Abmelden"-Link abbestellt werden, der sich in der E-Mail befindet.'}
                    </p>
                </div>

            </div>

        </div>
    );
};

export default Newsletter;
